import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { validLangs } from '@/mocks/languages';
import { articles, type Localized } from '@/mocks/articles';

type Lang = 'en' | 'fr' | 'da' | 'de';

export default function Articles() {
  const { t } = useTranslation();
  const { lang } = useParams();
  const currentLang = (lang && validLangs.includes(lang) ? lang : 'en') as Lang;

  const pick = (v: Localized) => v[currentLang];

  return (
    <section id="articles" className="w-full bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
            {t('home.articles.title')}
          </h2>
          <p className="mt-2 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            {t('home.articles.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articles.map((a) => (
            <Link
              key={a.slug}
              to={`/${currentLang}/${a.slug}`}
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="w-full h-40 md:h-44 overflow-hidden">
                <img
                  src={a.image}
                  alt={pick(a.title)}
                  title={`${pick(a.title)} AllChinaBuy Spreadsheet`}
                  className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2 py-0.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-2">
                  {pick(a.category)}
                </span>
                <h3 className="font-heading font-semibold text-foreground-950 text-base md:text-lg leading-snug">
                  {pick(a.title)}
                </h3>
                <p className="mt-2 text-foreground-600 text-xs md:text-sm leading-relaxed line-clamp-2">
                  {pick(a.summary)}
                </p>
                <p className="mt-3 flex items-center gap-1 text-foreground-500 text-xs">
                  <i className="ri-time-line"></i>
                  {pick(a.readTime)}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}